import React, { useState, useCallback, createContext } from "react";

export const APIErrorContext = createContext({
	error: null,
	addError: () => {},
	removeError: () => {},
	showLoader: false,
	setLoader: () => {},
	isViewDetailsOpen: false,
	setViewDetailsOpen: () => {},
});

export default function APIErrorProvider({ children }) {
	const [error, setError] = useState(null);
	const [showLoader, setShowLoader] = useState(false);
	const [isViewDetailsOpen, setIsViewDetailsOpen] = useState(false);

	const removeError = () => {
		setError(null);
		setShowLoader(false);
	};

	const addError = (message, status) => {
		setError({ message, status });
		setShowLoader(false);
	};

	const setLoader = (flag) => setShowLoader(flag);
	const setViewDetailsOpen = (flag) => setIsViewDetailsOpen(flag);

	const contextValue = {
		error,
		addError: useCallback((message, status) => addError(message, status), []),
		removeError: useCallback(() => removeError(), []),
		showLoader,
		setLoader: useCallback((flag) => setLoader(flag), []),
		isViewDetailsOpen,
		setViewDetailsOpen: useCallback((flag) => setViewDetailsOpen(flag), []),
	};

	return (
		<APIErrorContext.Provider value={contextValue}>
			{children}
		</APIErrorContext.Provider>
	);
}
